import React from 'react';
import { useWindowDimensions } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

interface EmptyStateProjectFilesProps {
  onDropZoneClick?: () => void;
}

const EmptyStateProjectFiles: React.FC<EmptyStateProjectFilesProps> = ({
  onDropZoneClick,
}) => {
  const { width } = useWindowDimensions();

  // Calculate icon size similar to other empty states
  let ICON_SIZE;
  if (width > 768) {
    ICON_SIZE = 200;
  } else if (width > 375) {
    ICON_SIZE = 180;
  } else {
    ICON_SIZE = 160;
  }

  return (
    <Box
      flex={1}
      justifyContent='center'
      alignItems='center'
      paddingHorizontal='m'
      paddingVertical='xl'>
      <div
        onClick={onDropZoneClick}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          cursor: 'pointer',
        }}>
        <Box alignItems='center' gap='xs'>
          {/* NoProjectFile Icon */}
          <Box alignItems='center' justifyContent='center'>
            <Icon name='NoProjectFile' width={ICON_SIZE} height={ICON_SIZE} />
          </Box>

          <Box gap='xxs'>
            <Text
              variant='heading2'
              color='textPrimary'
              textAlign='center'
              fontWeight='600'>
              Drop files here or click to upload
            </Text>

            {/* Supported Files Information */}
            <Text variant='body' color='grey04' textAlign='center'>
              Supports image, video, and document files
            </Text>
          </Box>
        </Box>
      </div>
    </Box>
  );
};

export default EmptyStateProjectFiles;
